<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <b-row class="row">
      <b-col sm="12">
        <b-card>
          <b-row class="p-2">
            <b-col sm="3">
              <rating-filter @ratingOption="handleRatingOption"></rating-filter>
            </b-col>
            <b-col sm="3">
              <date-picker v-model="dateRange"
                           range
                           append-to-body
                           :lang="$i18n.locale"
                           confirm
                           @change="handleDate"
                           valueType="timestamp"
                           :placeholder="$t('pages.feedbacks.date_range')"
                           format="DD/MM/YYYY"></date-picker>
            </b-col>
          </b-row>
        </b-card>
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6 col-12">
                    <PerPageSelector v-model="query.perPage"
                                     :available-per-page-options="availablePerPageOptions"
                    ></PerPageSelector>
                  </div>
                  <div class="col-sm-3 offset-lg-3 offset-md-3 offset-sm-3 col-12">
                    <DataTableSearch v-model="query.filter"
                                     :place-holder="$t('pages.review.show.search')">
                    </DataTableSearch>
                  </div>
                </div>
              </div>
              <div>
                <b-table
                    ref="reviewsTable"
                    striped
                    hover
                    :empty-text="$t('components.bootstrap_table.empty_text')"
                    :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
                    show-empty
                    :fields="fields"
                    :items="getReviews"
                    :stacked="$store.state.app.isMobile"
                    :filter="query.filter"
                    :per-page="query.perPage"
                    :sort-by="query.sortBy"
                    :sort-desc="query.sortDesc"
                    :current-page="query.page"
                >
                  <template v-slot:cell(rating)="data">
                    <star :star="parseFloat(data.item.rating)"></star>
                  </template>

                  <template v-slot:cell(verified_purchase)="data">
                    <f-badge :variant="data.item.verified_purchase ? 'success' : 'danger'">
                      {{ $t(`common.${data.item.verified_purchase ? 'yes' : 'no'}`) }}
                    </f-badge>
                  </template>

                </b-table>
                <div class="row">
                  <div class="col-sm">
                    <Pagination v-model="query.page" :meta="reviews.meta"></Pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col sm="8">
        <product-reviews :data="chartData"></product-reviews>
      </b-col>
      <b-col sm="4">
        <review-pie-chart :reviewPercent="reviewPercent"></review-pie-chart>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Pagination from "../../../components/Pagination";
import queryBuilder from "../../../mixins/queryBuilder";
import DataTableSearch from "../../../components/DataTableSearch";
import PerPageSelector from "../../../components/PerPageSelector";
import ReviewService from "../../../Services/Api/ReviewService";
import Star from "./Star";
import ProductReviews from "./ProductReviews";
import ReviewPieChart from "./Reviews/ReviewPieChart";
import RatingFilter from "./RatingFilter";
import ReviewStatMixin from "../../../mixins/ReviewStatMixin";
import DatePicker from "vue2-datepicker";

export default {
  name: "ShowReviews",
  mixins: [queryBuilder, ReviewStatMixin],
  components: {
    RatingFilter,
    ReviewPieChart,
    ProductReviews,
    PerPageSelector,
    DataTableSearch,
    Pagination,
    Star,
    DatePicker
  },
  page() {
    return {
      title: this.$t('pages.review.show.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      items: [
        {
          text: this.$t('pages.review.show.items.first'),
          href: "/reviews",
        },
        {
          text: this.$t('pages.review.show.items.second'),
          active: true,
        },
      ],
      title: this.$t('pages.review.show.title'),
      dateRange: null,
      templateType: null,
      ratingOption: null,
      reviews: [],
      productId: null,
      monthlyCounts: null,
      reviewPercent: null,
      chartData: null,
      fields: [
        {key: 'name', sortable: false, label: this.$t('pages.review.show.fields.buyer')},
        {key: 'rating', sortable: false, label: this.$t('pages.review.show.fields.rating'), tdClass: 'star-cell'},
        {key: 'title', sortable: false, label: this.$t('pages.review.show.fields.title')},
        {key: 'review', sortable: false, label: this.$t('pages.review.show.fields.review')},
        {key: 'verified_purchase', sortable: false, label: this.$t('pages.review.show.fields.verified')},
        {key: 'date', sortable: true, label: this.$t('pages.review.show.fields.date'), tdClass: 'date-cell'},
      ],
    }
  },
  methods: {
    async getReviews(params = this.query) {
      this.query = {...this.query, ...params}
      this.query.productId = this.productId
      const query = this.buildQuery()
      const {data: reviews} = await ReviewService.all({query})
      this.reviews = reviews
      return reviews.data
    },
    handleDate(e) {
      this.query.date = e[0] ? e.join(',') : null
      this.$refs.reviewsTable.refresh()
    },
    handleRatingOption(e) {
      this.query.ratingOption = e
      this.$refs.reviewsTable.refresh()
    },
    async getCountsMonthly() {
      const {data: statistics} = await ReviewService.countsMonthly({query: `productId=${this.productId}`})
      this.chartData = statistics.data
      this.reviewPercent = this.productReviewPercent(statistics.data)
    }
  },
  created() {
    this.productId = this.$route.params.productId
    this.getCountsMonthly()
  }
}
</script>

<style scoped>
.item-name {
  overflow: hidden;
  width: 220px;
}

/deep/ .star-cell {
  min-width: 10em !important;
}

/deep/ .date-cell {
  min-width: 8em !important;
}
</style>